import * as React from 'react';
import style from './check-box.scss';

export interface CheckBoxProps {
  name: string;
  label?: string;
  error?: string;
  helpText?: string;
  touched?: boolean;
}

type InputProps = JSX.IntrinsicElements['input'];

export function CheckBox(props: CheckBoxProps & InputProps) {
  const {
    label,
    error,
    helpText,
    name,
    required,
    touched,
    ...restProps
  } = props;

  const showHelp = Boolean(helpText);
  const showError = Boolean(touched && error);

  return (
    <React.Fragment>
      <input
        className="marketing-checkbox"
        id={name}
        name={name}
        type="checkbox"
        {...restProps}
      />
      {/* eslint-disable jsx-a11y/label-has-for */}
      <label
        className="marketing-checkbox-label"
        htmlFor={name}
      >
        {label}
        {showError && <span className={style.error}>{error}</span>}
        {showHelp && <span className={style.help}>{helpText}</span>}
      </label>
      {/* eslint-enable jsx-a11y/label-has-for */}
    </React.Fragment>
  );
}
